import { usePage } from '@inertiajs/react';
import { VideoLandingPage } from '@/components/public/VideoLandingPage';
import type { VideoLandingConfig } from '@/components/public/VideoLandingPage';

type PageProps = {
  videoProvider: 'youtube' | 'loom';
  videoId: string;
  calendarUrl?: string;
  [key: string]: unknown;
};

const IaPsicologi = () => {
  const { videoProvider, videoId, calendarUrl } = usePage<PageProps>().props;

  const config: VideoLandingConfig = {
    pageTitle: 'Intelligenza Artificiale in psicologia — Emovia',
    badge: 'IA per psicologi',
    headline: "Emovia è l'IA che mette al centro il lavoro clinico",
    lead: 'Non tutti gli strumenti intelligenza artificiale sono uguali. Emovia è un diario guidato con IA interrogativa, progettato per psicologi: fa domande, non interpreta.<br/>Il lavoro clinico resta tuo.',
    videoProvider,
    videoId,
    videoTitle: 'Emovia — come funziona',
    supportCopy:
      'Abbiamo realizzato questo video di 3 minuti per farti capire come funziona concretamente.',
    ctaLabel: 'Fissa un appuntamento',
    ctaLocation: 'landing_ia_psicologi_cta',
    calendarUrl,
  };

  return <VideoLandingPage config={config} />;
};

export default IaPsicologi;
